import styled from 'styled-components';

export const Label = styled.span`
  padding-right: ${({ theme }) => theme.spacing(6)};
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  font-size: ${({ theme }) => theme.pxToRem(14)};
  line-height: 1.5;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 120px;
`;

export const IconContainer = styled.section`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ theme }) => theme.pxToRem(22)};
  height: ${({ theme }) => theme.pxToRem(22)};
  border: 1px solid ${({ theme }) => theme.colours.crowberryBlue};
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colours.white};

  svg {
    color: ${({ theme }) => theme.colours.crowberryBlue};
    width: 13px;
    height: 13px;
  }
`;

export const LabelIconContainer = styled.div`
  padding-right: ${({ theme }) => theme.spacing(6)};
  padding-left: ${({ theme }) => theme.spacing(6)};
  display: inline-flex;
  align-items: left;
  justify-content: flex-start;
  height: 24px;
`;
